import React from 'react';
import Loader from 'Components/common/page/loader';

const LoaderHOC = (WrappedComponent) => (props) => props.isFetching ? <Loader /> : <WrappedComponent {...props} />

export default LoaderHOC;